import React, { lazy, Suspense } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';

// for the moment, the following are borrow from Explorer, which may cause large explorer app chunks to load, should be factored
import SingleLayout from '@explorer/components/layout/SingleLayout';
import RouterWrapper from '@explorer/components/layout/RouterWrapper';

import { localPaths } from '@mirinae/auth/modules/defines/paths';
import LoadingSpinner from '@mirinae/react-ui/components/spinner/LoadingSpinner';

import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
const EmailSignUp = lazy(() => import(/* webpackChunkName: "EmailSignUp" */ './pages/EmailSignUp'));
const ResetPassword = lazy(() => import(/* webpackChunkName: "ResetPassword" */ './pages/ResetPassword'));
const Withdraw = lazy(() => import(/* webpackChunkName: "Withdraw" */ './pages/Withdraw'));
const AccountConfirmed = lazy(() => import(/* webpackChunkName: "AccountConfirmed" */ './pages/AccountConfirmed'));

const Auth = () => {
    const params = useParams();

    return (
        <SingleLayout>
            <RouterWrapper>
                <Suspense fallback={LoadingSpinner}>
                    <Routes>
                        <Route path={localPaths.login} element={<Login />}/>
                        <Route path={localPaths.signup} element={<SignUp />}/>
                        <Route path={localPaths.emailSignUp} element={<EmailSignUp />}/>
                        <Route path={localPaths.resetPassword} element={<ResetPassword />}/>
                        <Route path={localPaths.withdraw} element={<Withdraw />}/>
                        <Route path={localPaths.accountConfirmed} element={<AccountConfirmed signupBy={params.signupBy} />}/>
                    </Routes>
                </Suspense>
            </RouterWrapper>
        </SingleLayout>
    );
};

export default Auth;
